const reducer = (state, action) => {
  switch (action.type) {
    case "increaseCounter":
      return {
        ...state,
        counter: state.counter + 1
      };
    case "decreaseCounter":
      return {
        ...state,
        counter: state.counter - 1
      };
    default:
      return state;
  }
};

export default reducer